exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_breadcrumb__qeygb{font-size:.875rem;line-height:1rem;color:#9e9e9e}.style_breadcrumb__qeygb .style_breadcrumbLink__20imO{color:#333;text-decoration:none}.style_breadcrumb__qeygb .style_breadcrumbLink__20imO>:active,.style_breadcrumb__qeygb .style_breadcrumbLink__20imO>:visited{color:#333}.style_breadcrumb__qeygb .style_breadcrumbLink__20imO:hover{color:#2f93e0}", ""]);

// exports
exports.locals = {
	"breadcrumb": "style_breadcrumb__qeygb",
	"breadcrumbLink": "style_breadcrumbLink__20imO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Breadcrumb/style.less
// module id = 1300
// module chunks = 8